export class SortModel {
  constructor(public target = '', public order = 'ASC') {}
}
